import { grey as greyColor } from '@mercedes-benz/mui5-theme/build/main/lib/Colors';
import { Theme } from '@mui/material';
import { WbListGroup, WbListGroupItem, WbText } from '@workbench/react';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from '../../../common/i18n/useTranslation';
import { Routes } from '../../../routes/routes';
import { useNavigation } from '../../../utils/customHooks';
import TaskMenuItem from './TaskMenuItem';
import { TaskDto } from '../../../api';
import { useTasksData } from '../../client/companyRegistration/hooks/useTasksData';
import { getTaskCount } from '../../admin/products/ProductHelper';
import {
    ExtendedTaskType,
    FILTER_REVERSE_MAP,
    getIcon,
    getTaskTypes,
    PRODUCT_APPROVAL_RENEWAL_REQUIRED,
} from './TaskSectionHelper';

const useStyles = makeStyles()((theme: Theme) => ({
    div: {
        backgroundColor: theme.palette.common.white,
        maxWidth: theme.spacing(45),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    tasksText: {
        marginLeft: theme.spacing(3),
        color: greyColor[35],
    },
    textColor: {
        color: greyColor[35],
    },
}));

function TasksSection() {
    const { classes } = useStyles();
    const navigateTo = useNavigation();
    const translate = useTranslation();
    const { tasks } = useTasksData();

    const getCount = (tasksType: ExtendedTaskType) => {
        // Vorgangsbasiert zaehlen; fuer Renewal/Annual Report entspricht das den Formulierungs-Tasks.
        return getTaskCount(tasksType, tasks);
    };
    const getTaskTypeText = (taskType: ExtendedTaskType) => {
        switch (taskType) {
            case TaskDto.type.PRODUCT_RELEASE_ENGAGEMENT_ACTION_REQUIRED:
                return translate('sign_release_engagement');
            case TaskDto.type.PRODUCT_INVOICE_ACTION_REQUIRED:
                return translate('invoice_open');
            case TaskDto.type.PRODUCT_FORMULATION_ANNUAL_REPORT_DUE:
                return translate('annual_report_due');
            case TaskDto.type.PRODUCT_FORMULATION_ANNUAL_REPORT_OVERDUE:
                return translate('annual_report_overdue');
            case TaskDto.type.PRODUCT_CERTIFICATE_ACTION_REQUIRED:
                return translate('download_certificate');
            case TaskDto.type.COMPANY_INVOICE_OPEN:
                return translate('company_registration_fee_open');
            case TaskDto.type.PRODUCT_APPROVAL_REWORK_NECESSARY:
                return translate('revised_application');
            case TaskDto.type.PRODUCT_APPROVAL_REJECTED:
                return translate('process_rejected');
            case PRODUCT_APPROVAL_RENEWAL_REQUIRED:
                return translate('renewal_approval');
            default:
                return '';
        }
    };

    const hasTasks = () => getTaskTypes().some((type) => getCount(type) > 0);

    const handleNavigate = async (taskType: ExtendedTaskType) => {
        const queryParam = FILTER_REVERSE_MAP[taskType];

        if (taskType === TaskDto.type.COMPANY_INVOICE_OPEN) {
            // Navigate to my company and scroll to invoice section
            await navigateTo(Routes.dashboard_my_company, undefined, queryParam);
        } else {
            // Navigate to product overview with filter
            await navigateTo(Routes.product, { filter: queryParam });
        }
    };
    return (
        <div className={classes.div}>
            <WbText size="l" strong className={classes.tasksText}>
                {translate('tasks')}
            </WbText>
            <WbListGroup hide-border>
                {hasTasks() ? (
                    getTaskTypes().map((type) => {
                        return (
                            <TaskMenuItem
                                key={type}
                                counter={getCount(type)}
                                label={getTaskTypeText(type)}
                                handle={() => handleNavigate(type)}
                                icon={getIcon(type)}
                            />
                        );
                    })
                ) : (
                    <WbListGroupItem>
                        <WbText className={classes.textColor}>{translate('no_open_tasks_available')}</WbText>
                    </WbListGroupItem>
                )}
            </WbListGroup>
        </div>
    );
}

export default TasksSection;
